import moment from 'moment';
import { AuctionStatus, BidPaymentStatus, BidStatus } from 'src/api/auctionApi';

import { BidResult } from 'src/pages/Auction/BidInfo/BidResultEnum';

export class AuctionUtils {
  static getBidResult(
    paymentStatus?: BidPaymentStatus,
    bidStatus?: BidStatus,
    auctionStatus?: AuctionStatus,
    isAuctionClosed?: boolean,
    isWinningBid?: boolean
  ): BidResult {
    if (
      paymentStatus === BidPaymentStatus.PAYMENT_HOLD_FAILED ||
      paymentStatus === BidPaymentStatus.FAILED
    ) {
      return BidResult.UNSUCCESSFUL;
    } else if (isAuctionClosed) {
      if (auctionStatus !== AuctionStatus.CLOSED) {
        return BidResult.AUCTION_CLOSING;
      }

      return isWinningBid && paymentStatus === BidPaymentStatus.PAID
        ? BidResult.SUCCESSFUL
        : BidResult.UNSUCCESSFUL;
    } else if (paymentStatus === BidPaymentStatus.PENDING) {
      return BidResult.PENDING_SEAT;
    } else if (bidStatus === BidStatus.PROCESSING) {
      return BidResult.PROCESSING;
    } else {
      return isWinningBid ? BidResult.HOLD_SEAT : BidResult.OUT_BID;
    }
  }

  static isAuctionClosed(closeDate?: string): boolean {
    if (!closeDate) {
      return false;
    }

    const now = moment();
    const endDate = moment(closeDate);

    if (!endDate.isValid()) {
      return false;
    }

    return now.isAfter(endDate);
  }

  static getMinimumBidAmount(auction: any, bidAmount: number = 0) {
    return Math.max(
      auction.bidDetails.lowestAvailableBid,
      auction.valid_bid_amounts
        .filter((validBidAmount: number) => validBidAmount > bidAmount)
        .shift() ?? 0
    );
  }

  static formatDollars(cents: number, decimalPlaces: number = 2): string {
    const dollars = cents / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(dollars);
  }
}
